import { useEffect, useRef } from 'react';

const LINK_DIST = 92;

// Partículas flutuam e ganham uma linha entre si quando estão perto.
function ParticleBackground() {
  const ref = useRef(null);

  useEffect(() => {
    const cv = ref.current;
    const ctx = cv.getContext('2d');
    let pts = [];
    let id;

    const measure = () => {
      cv.width = window.innerWidth;
      cv.height = window.innerHeight;
      const count = Math.min(90, Math.round((cv.width * cv.height) / 16000));
      pts = Array.from({ length: count }, () => ({
        x: Math.random() * cv.width,
        y: Math.random() * cv.height,
        vx: (Math.random() - 0.5) * 0.45,
        vy: (Math.random() - 0.5) * 0.45,
      }));
    };

    const step = () => {
      ctx.clearRect(0, 0, cv.width, cv.height);
      pts.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > cv.width) p.vx *= -1;
        if (p.y < 0 || p.y > cv.height) p.vy *= -1;
        ctx.fillStyle = 'rgba(97,218,251,.85)';
        ctx.beginPath();
        ctx.arc(p.x, p.y, 1.8, 0, 6.284);
        ctx.fill();
      });
      for (let i = 0; i < pts.length; i++) {
        for (let j = i + 1; j < pts.length; j++) {
          const d = Math.hypot(pts[i].x - pts[j].x, pts[i].y - pts[j].y);
          if (d < LINK_DIST) {
            ctx.strokeStyle = `rgba(97,218,251,${0.3 * (1 - d / LINK_DIST)})`;
            ctx.beginPath();
            ctx.moveTo(pts[i].x, pts[i].y);
            ctx.lineTo(pts[j].x, pts[j].y);
            ctx.stroke();
          }
        }
      }
      id = requestAnimationFrame(step);
    };

    measure();
    window.addEventListener('resize', measure);
    id = requestAnimationFrame(step);
    return () => {
      cancelAnimationFrame(id);
      window.removeEventListener('resize', measure);
    };
  }, []);

  return <canvas ref={ref} className="particle-bg" />;
}

export default ParticleBackground;
